import Model from "../../Model";
import { actions } from '@/store';

class categories extends Model{

    buildUrl ({ param }) {        
        return ['stock/categories', param];
    }
//
//    all(config = {}) {
//        return this.request({ method: 'GET', action: 'all', ...config });
//    }

    afterRequest({ data }) {
        actions.setStockCategories(data.data.categories)
    }
}


export default new categories;